import React from 'react'
import FeedbackForTeacher from '../components/MT_Score/FeedbackForTeacher'
import ScoreViewHeaderForTeacher from '../components/MT_Score/ScoreViewHeaderForTeacher'

const MtScoreFeedbackForTeacher = () => {
  return (
    <>
    <ScoreViewHeaderForTeacher />
    <FeedbackForTeacher />
    </>
  )
}

export default MtScoreFeedbackForTeacher